import React from 'react';
import { Player, BigPlayButton } from 'video-react';

import 'video-react/dist/video-react.css';
import './index.scss';

export default ({ t, src, preview, text, onPlay, active }) => {
  // play button disabled with css style
  const config = {
    src,
    autoPlay: true,
    playsInline: true,
    preload: 'none',
  };

  return (
    <div className="video-player" onClick={onPlay}>
      {active ? (
        <div className="video-player--container">
          <Player {...config}>
            <BigPlayButton position="center" />
          </Player>
          <a className="video-player--download-button" href={src}>
            <span className="video-player--download-icon" />
            <span className="video-player--download-text">
              {t('videoPlayer.downloadButton')}
            </span>
          </a>
        </div>
      ) : (
        <div
          className="video-player--preview"
          style={{ backgroundImage: `url(${preview})` }}
        >
          <div className="video-player--preview--caption">{text}</div>
        </div>
      )}
    </div>
  );
};



// WEBPACK FOOTER //
// /app/apps/ms/src/components/Carousel/VideoPlayer/index.js